/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { useIntl } from "react-intl";
// import { KTIcon } from "../../../../helpers";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { useAuth } from "../../../../../app/modules/auth";

const SidebarMenuMain = () => {
  const { currentUser, logout } = useAuth();
  const intl = useIntl();

  return (
    <>
      <SidebarMenuItem
        to="/advertisement"
        icon="advt-svg"
        title={intl.formatMessage({ id: "Advertisement" })}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItemWithSub
        to="/crafted/airports"
        title="Airports"
        icon="paws-svg"
        fontIcon="bi-person"
      >
        <SidebarMenuItem
          to="/crafted/airports/add-airports"
          title="Add Airport"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/airports/all-airports"
          title="All Airports"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/airports/frequently-searched"
          title="Frequently Searched"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/airports/airport-review"
          title="Airport Review"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="/crafted/pet-relief-areas"
        title="Pet Relief Areas"
        icon="paws-svg"
        fontIcon="bi-person"
      >
        <SidebarMenuItem
          to="/crafted/pet-relief-areas/add-pet-relief-areas"
          title="Add Pet Relief Area"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/pet-relief-areas/all-pet-relief-areas"
          title="All Pet Relief Areas"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/pet-relief-areas/pet-relief-area-review"
          title="Pet Relief Area Review"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem to="/users" icon="user-svg" title="Users" />
      <SidebarMenuItem
        to="/media"
        icon="videos"
        title={intl.formatMessage({ id: "Media" })}
        fontIcon="bi-app-indicator"
      />

      <SidebarMenuItem
        to="/add-banners"
        icon="banner-icon"
        title="Add Pop-Up Banners"
        fontIcon="bi-layers"
      />

      <SidebarMenuItem
        to="/add-about"
        icon="about-svg"
        title="About"
        fontIcon="bi-layers"
      />
      <SidebarMenuItem
        to="/our-story"
        icon="ourstory-svg"
        title="Our Story"
        fontIcon="bi-layers"
      />
      <SidebarMenuItem
        to="/send-notification"
        icon="notif-svg"
        title="Send Notifications"
        fontIcon="bi-layers"
      />
      <SidebarMenuItem
        to="/app-update"
        icon="banner-icon"
        title="App Update"
        fontIcon="bi-arrow-up-circle"
      />
      <SidebarMenuItem
        to="/app-branding"
        icon="banner-icon"
        title="App Logo"
        fontIcon="bi-image"
      />
      <SidebarMenuItem
        to="/app-icon"
        icon="banner-icon"
        title="App Icon"
        fontIcon="bi-phone"
      />
      <SidebarMenuItem
        to="/auth"
        icon="logout-svg"
        title="Logout"
        fontIcon="bi-layers"
        onclick={logout}
      />
      {/* <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Crafted
          </span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to="/crafted/pages"
        title="Pages"
        fontIcon="bi-archive"
        icon="element-plus"
      >
        <SidebarMenuItemWithSub
          to="/crafted/pages/profile"
          title="Profile"
          hasBullet={true}
        >
          <SidebarMenuItem
            to="/crafted/pages/profile/overview"
            title="Overview"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/projects"
            title="Projects"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/campaigns"
            title="Campaigns"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/documents"
            title="Documents"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/profile/connections"
            title="Connections"
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub
          to="/crafted/pages/wizards"
          title="Wizards"
          hasBullet={true}
        >
          <SidebarMenuItem
            to="/crafted/pages/wizards/horizontal"
            title="Horizontal"
            hasBullet={true}
          />
          <SidebarMenuItem
            to="/crafted/pages/wizards/vertical"
            title="Vertical"
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to="/error"
        title="Errors"
        fontIcon="bi-sticky"
        icon="cross-circle"
      >
        <SidebarMenuItem to="/error/404" title="Error 404" hasBullet={true} />
        <SidebarMenuItem to="/error/500" title="Error 500" hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to="/crafted/widgets"
        title="Widgets"
        icon="element-7"
        fontIcon="bi-layers"
      >
        <SidebarMenuItem
          to="/crafted/widgets/lists"
          title="Lists"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/statistics"
          title="Statistics"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/charts"
          title="Charts"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/mixed"
          title="Mixed"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/tables"
          title="Tables"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/crafted/widgets/feeds"
          title="Feeds"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub> */}
      {/* <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Apps
          </span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to="/apps/chat"
        title="Chat"
        fontIcon="bi-chat-left"
        icon="message-text-2"
      >
        <SidebarMenuItem
          to="/apps/chat/private-chat"
          title="Private Chat"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/apps/chat/group-chat"
          title="Group Chart"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/apps/chat/drawer-chat"
          title="Drawer Chart"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to="/apps/user-management/users"
        icon="abstract-28"
        title="User management"
        fontIcon="bi-layers"
      />
      <div className="menu-item">
        <a
          target="_blank"
          className="menu-link"
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + "/docs/changelog"}
        >
          <span className="menu-icon">
            <KTIcon iconName="code" className="fs-2" />
          </span>
          <span className="menu-title">
            Changelog {process.env.REACT_APP_VERSION}
          </span>
        </a>
      </div> */}
    </>
  );
};

export { SidebarMenuMain };
